//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

    props: ['website'],
    data: function data() {
        return {
            pageList: [{
                name: 'Home',
                slug: '/',
                last_updated: '14:26:09 on 05/15/2019',
                updated_by: 'Admin',
                alias: 'Home'
            }, {
                name: 'Amenities',
                slug: '/amenities',
                last_updated: '14:26:09 on 05/15/2019',
                updated_by: 'Admin',
                alias: 'Amenities'
            }, {
                name: 'Floor Plans',
                slug: '/floorplans',
                last_updated: '14:26:09 on 05/15/2019',
                updated_by: 'Admin',
                alias: 'Floor Plan Page'
            }, {
                name: 'Neighborhood',
                slug: '/neighborhood',
                last_updated: '14:26:09 on 05/15/2019',
                updated_by: 'Admin',
                alias: 'Neighborhood'
            }]
        };
    },

    methods: {
        setPage: function setPage(page) {
            Event.$emit('change-page', page);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cms/pages/PageList.vue
// module id = m/a8
// module chunks = 0 1